<template>
  <div id="add-user" class="m-t-10">
    <form action="#" v-on:submit.prevent="submitForm">
      <div class="form-group">
        <label for="input-nama">Tanggal</label>
        <div class="form-group">
          <v-date-picker v-model="date" :masks="masks" is-required>
            <template v-slot="{ inputValue, inputEvents }">
              <input
                class="bg-white border px-2 py-1 rounded form-control"
                :value="inputValue"
                v-on="inputEvents"
                required
              />
            </template>
          </v-date-picker>
        </div>
      </div>
      <div class="form-group">
        <label for="input-username">Jumlah Berita</label>
        <div class="form-group">
          <input
            type="number"
            name="count"
            value=""
            id="input-count"
            class="form-control"
            placeholder="jumlah berita"
            required
            v-model="count"
          />
        </div>
      </div>
      <div class="form-group" align="right">
        <button type="button" class="btn btn-danger m-r-5" data-dismiss="modal">
          Batal
        </button>
        <button type="submit" class="btn btn-primary">Simpan</button>
      </div>
    </form>
  </div>
</template>

<script>
import $ from "jquery";
import notif from "@/assets/js/notif.js";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import moment from "moment";
$.pgNotification = notif;

export default {
  name: "AddTrend",
  data() {
    return {
      date: null,
      count: null,
      id_stream: this.$route.query.q,
      masks: {
        input: "DD MMM YYYY",
        inputDateTime24hr: "DD MMM YYYY",
      },
    };
  },
  components: {
    "v-date-picker": DatePicker,
  },
  methods: {
    submitForm: function () {
      if (this.date != null && this.count != null) {
        let params = {
          count: parseInt(this.count),
          date: moment(this.date).format("YYYY-MM-DD"),
          parent: this.id_stream,
        };
        let api = process.env.VUE_APP_API_URL + "newstrend/save-trend";
        this.$http
          .post(api, params)
          .then((response) => {
            if (response.status == 200) {
              this.$parent.$parent.getData();

              $("#modalSlideUp").modal("hide");
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-check-circle"></i> <b>Berhasil!</b>Trend berhasil ditambahkan!',
                  position: "top",
                  timeout: 5000,
                  type: "success",
                })
                .show();
            }
          })
          .catch(() => {
            $("#modalSlideUp").modal("hide");
            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan pada saat menambahkan User!',
                position: "top",
                timeout: 5000,
                type: "danger",
              })
              .show();
          });
      } else {
        alert("pastikan semua field terisi");
      }
    },
  },
};
</script>

<style scoped>
.form-control {
  -webkit-appearance: button;
}
select {
  cursor: pointer;
}
</style>